import { render, staticRenderFns } from "./VForm.vue?vue&type=template&id=d2424b5c&scoped=true"
import script from "./VForm.vue?vue&type=script&lang=js"
export * from "./VForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2424b5c",
  null
  
)

export default component.exports